module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../~/path-to-regexp/~/isarray/index.js
// module id = 349
// module chunks = 0